<template>
  <v-container class="home">
    <v-row class="my-2">
      <v-col>
        <v-sheet outlined style="text-align: center" class="crane-border-white">
          <v-row>
            <v-col><h2 class="mt-5">Programs</h2></v-col>
          </v-row>
          <v-simple-table class="ma-3" style="text-align: left">
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Out</th>
                  <th>Due</th>
                  <th>CS167</th>
                  <th>CS169</th>
                  <th>CS267</th>
                  <th>Name</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in projects" :key="item.name">
                  <td>{{ item.out }}</td>
                  <td>{{ item.due }}</td>
                  <td>
                    <v-icon v-if="item.cs167 == 1" small>mdi-check</v-icon>
                  </td>
                  <td>
                    <v-icon v-if="item.cs169 == 1" small>mdi-check</v-icon>
                  </td>
                  <td>
                    <v-icon v-if="item.cs267 == 1" small>mdi-check</v-icon> 
                  </td>
                  <td>
                    <div v-if="item.url">
                      <a :href="item.url">{{ item.name }}</a>
                    </div>
                    <div v-else>
                      {{ item.name }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-row>
            <v-col><h2 class="mt-5">Homeworks</h2></v-col>
          </v-row>
          <v-simple-table class="ma-3" style="text-align: left">
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Out</th>
                  <th>Due</th>
                  <th>CS167</th>
                  <th>CS169</th>
                  <th>CS267</th>
                  <th>Name</th>
                  <th>Downloads</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in homeworks" :key="item.name">
                  <td>{{ item.out }}</td>
                  <td>{{ item.due }}</td>
                  <td>
                    <v-icon v-if="item.cs167 == 1" small>mdi-check</v-icon>
                  </td>
                  <td>
                    <v-icon v-if="item.cs169 == 1" small>mdi-check</v-icon>
                  </td>
                  <td>
                    <v-icon v-if="item.cs267 == 1" small>mdi-check</v-icon>
                  </td>
                  <td>{{ item.name }}</td>
                  <td>
                    <a v-if="item.handout" :href="item.handout" target="_blank" >Handout</a>
                    <span v-else>Handout</span>
                    &nbsp;
                    <a v-if="item.solution" :href="item.solution" target="_blank">Solution</a>
                    <span v-else>Solution</span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-row>
            <v-col><h2 class="mt-5">Calendar</h2></v-col>
          </v-row>
          <v-row class="ma-3">
            <v-col style="width: 100%; overflow: auto">
              <iframe
                src="https://calendar.google.com/calendar/embed?src=c_625ccii0dq83im5558ptntmb3s%40group.calendar.google.com&ctz=America%2FNew_York"
                class="mx-auto"
                style="border: 0"
                width="800"
                height="600"
                frameborder="0"
                scrolling="no"
              ></iframe>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data: () => ({
    projects: [
      {
        out: "Jan 28",
        due: "Feb 9",
        cs167: 1,
        cs169: 1,
        cs267: 1, 
        name: "uthreads",
        url: "https://github.com/brown-cs1690/handout/wiki/uthreads",
        gearup: "",
        slides: "",
      },
      {
        out: "Jan 31",
        due: "Feb 14",
        cs167: 0,
        cs169: 1,
        cs267: 1,
        name: "Weenix - Processes",
        url: "https://github.com/brown-cs1690/handout/wiki/Getting-Started-with-Weenix",
        gearup: "",
        slides: "",
      },
      {
        out: "Feb 16",
        due: "Feb 28",
        cs167: 0,
        cs169: 1,
        cs267: 1,
        name: "Weenix - Drivers",
        url: "https://github.com/brown-cs1690/handout/wiki/Drivers",
        gearup: "",
        gearup_title: "",
        slides: "",
      },
      {
        out: "Feb 14",
        due: "Mar 4",
        cs167: 1,
        cs169: 1,
        cs267: 1,
        name: "mthreads",
        url: "https://github.com/brown-cs1690/handout/wiki/mthreads",
        gearup: "",
        slides: "",
      },
      {
        out: "Feb 28",
        due: "Mar 18",
        cs167: 0,
        cs169: 1,
        cs267: 1,
        name: "Weenix - VFS",
        url: "https://github.com/brown-cs1690/handout/wiki/Virtual-File-System",
        gearup: "",
        slides: "",
      },
      {
        out: "Mar 11",
        due: "Mar 23",
        cs167: 1,
        cs169: 0,
        cs267: 0,
        name: "VFS",
        url: "https://github.com/brown-cs1690/handout/wiki/Virtual-File-System-(167-edition)",
        gearup: "",
        slides: "",
      },
      {
        out: "Mar 18",
        due: "Apr 6",
        cs167: 0,
        cs169: 1,
        cs267: 1,
        name: "Weenix - S5FS",
        url: "https://github.com/brown-cs1690/handout/wiki/System-V-File-System",
        gearup: "",
        slides: "",
      },
      {
        out: "Apr 13",
        due: "May 13",
        cs167: 1,
        cs169: 0,
        cs267: 0,
        name: "S5FS",
        url: "https://github.com/brown-cs1690/handout/wiki/System-V-File-System",
        gearup: "",
        slides: "",
      },
      {
        out: "Apr 6",
        due: "May 13",
        cs167: 0,
        cs169: 1,
        cs267: 1,
        name: "Weenix - VM",
        url: "https://github.com/brown-cs1690/handout/wiki/Virtual-Memory",
        gearup: "",
        slides: ""
      },
    ],
    homeworks: [
      {
        out: "Feb 9",
        due: "Feb 18",
        cs167: 1,
        cs169: 1,
        cs267: 1,
        name: "Homework 1",
        handout: "content/homeworks/hw1.pdf",
        solution: "content/homeworks/hw1_ans.pdf"
      },
      {
        out: "Mar 7",
        due: "Mar 14",
        cs167: 1,
        cs169: 1,
        cs267: 1,
        name: "Homework 2",
        handout: "content/homeworks/hw2.pdf",
        solution: "content/homeworks/hw2_ans.pdf"
      },
      {
        out: "Apr 6",
        due: "Apr 13",
        cs167: 1,
        cs169: 1,
        cs267: 1,
        name: "Homework 3",
        handout: "content/homeworks/hw3.pdf",
				solution: "content/homeworks/hw3_ans.pdf"
      },
      {
        out: "Apr 27",
        due: "May 4",
        cs167: 1,
        cs169: 1,
        cs267: 1,
        name: "Homework 4",
        handout: "content/homeworks/hw4.pdf",
				solution: "content/homeworks/hw4_ans.pdf"
      },
    ],
  }),
};
</script>
<style scoped>

@import '../styles/crane.css';

.profile {
  width: 250px;
  margin: auto;
}

.profile img {
  width: 200px;
  height: 200px;
  object-fit: cover;
}
</style>
